import _createForOfIteratorHelper from "E:\\Agents\\Agent-04\\_work\\34\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "E:\\Agents\\Agent-04\\_work\\34\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\34\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PracticalInformation.css';
import React, { useEffect, useState } from 'react';
import { get, getDictionaryItem, canUseDOM } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { RichText, Text, Link as SitecoreLink } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import IconPlus from '../atoms/Icons/IconPlus';
import IconMinus from '../atoms/Icons/IconMinus';
import { ReactComponent as IconLocation } from '../../resources/icons/icon-location.svg';
import { ReactComponent as IconLink } from '../../resources/icons/icon-link.svg';
import { ReactComponent as IconMobile } from '../../resources/icons/icon-mobile-without-homeBtn.svg';
import { ReactComponent as IconTime } from '../../resources/icons/icon-time.svg';
import { ReactComponent as IconEmail } from '../../resources/icons/icon-email.svg';
import { ReactComponent as IconFee } from '../../resources/icons/IconFee.svg';
import { ReactComponent as IconDisclaimer } from '../../resources/icons/disclaimer.svg';
import { ReactComponent as IconCloseX } from '../../resources/icons/closeX.svg';
import GoogleMap from '../atoms/GoogleMaps/GoogleMaps';
import OSM from '../atoms/OpenStreetMap/OpenStreetMap';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import { useInView } from 'react-intersection-observer';
import { ReactComponent as ChevronDown } from '../../resources/icons/chevron-down.svg';
import GoogleMapStatic from '../atoms/GoogleMaps/GoogleMapsStatic';
import { isNotNil } from '../../utils/IsNil';
export var defaultMapState = {
  lat: 24.787745276115412,
  lng: 56.14390512664188,
  activeMarker: 0,
  markers: [{}]
};
export var PracticalInformation = function PracticalInformation(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var googlePlaceIDPOI = get(fields, 'data.contextItem.googlePlaceID.jss.value');
  // let locationTitle: string = ;
  var buyLinkWebsite = get(fields, 'data.contextItem.buyLinkWebsite.jss.value.href');
  var venues = get(fields, 'data.contextItem.venue.values');
  var googlePlaceIds = get(fields, 'data.contextItem.googlePlaceID.googlePlaceIds');
  /* const ColorHex = '#525252'; */
  var ColorHex = get(params, 'BackgroundColorHex', '--main-color');
  /* const ActiveColorHex = get(params, 'ActiveColorHex', '--main-color--active'); */
  var ActiveColorHex = get(params, 'BackgroundColorHex', '--main-color');
  var dictionary = get(fields, 'data.dictionary');
  var bookTickets = getDictionaryItem(dictionary, 'BookTickets');
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isStaticMap = _React$useState2[0],
    setIsStaticMap = _React$useState2[1];
  var _React$useState3 = React.useState({
      website: '',
      telephone: '',
      address: get(fields, 'data.contextItem.address.jss.value'),
      email: '',
      lat: 0,
      lng: 0,
      openingHoursVenue: '',
      bound: false,
      tripAdvisorPriceLevel: ''
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    mapInfo = _React$useState4[0],
    setMapInfo = _React$useState4[1];
  var _React$useState5 = React.useState(get(fields, 'data.contextItem.title.jss.value')),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    locationTitle = _React$useState6[0],
    setLocationTitle = _React$useState6[1];
  var _React$useState7 = React.useState(defaultMapState),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    mapState = _React$useState8[0],
    setMapState = _React$useState8[1];
  var _React$useState9 = React.useState([]),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    allLocations = _React$useState10[0],
    setAllLocations = _React$useState10[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    disclaimerOpen = _useState2[0],
    setDisclaimerOpen = _useState2[1];
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');

  //	 CONTEXT ITEM DATA
  var latJSS = get(fields, 'data.contextItem.latitude.jss.value') || '';
  var lngJSS = get(fields, 'data.contextItem.longitude.jss.value') || '';
  var telephoneJSS = get(fields, 'data.contextItem.phone.jss.value') || '';
  var emailJSS = get(fields, 'data.contextItem.email.jss.value') || '';
  var websiteJSS = get(fields, 'data.contextItem.website.jss.value.url') || '';
  var addressJSS = get(fields, 'data.contextItem.address.jss.value') || '';
  var openingHoursJSS = get(fields, 'data.contextItem.openingHours.jss.value') || '';
  var tripAdvisorPriceLevelJSS = get(fields, 'data.contextItem.tripAdvisorPriceLevel.jss.value');
  var titleJSS = get(fields, 'data.contextItem.title.jss.value');
  var locationTagsJSS = get(fields, 'data.contextItem.locationTag.targetItems') || [];
  var hasLocationTagsJSS = Boolean(locationTagsJSS);
  var googleMapsImageSrc = get(fields, 'data.contextItem.googleMapsImage.jss.value.src') || '';
  var googleMapsImageAlt = get(fields, 'data.contextItem.googleMapsImage.jss.value.alt') || '';
  var hasGoogleMapsImage = Boolean(get(fields, 'data.contextItem.googleMapsImage.jss.value.src'));

  //	 END CONTEXT ITEM DATA

  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var currentLang = get(sitecoreContext, 'language');
  var _React$useState11 = React.useState('Tab Title Overview'),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    activeTabItem = _React$useState12[0],
    setActiveTabItem = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    activeItemsIds = _React$useState14[0],
    setActiveItemsIds = _React$useState14[1];
  var _React$useState15 = React.useState(undefined),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isChina = _React$useState16[0],
    setIsChina = _React$useState16[1];
  var disclaimerText = get(fields, 'data.datasource.disclaimerText.jss.value');
  var titleField = get(fields, 'data.datasource.faqHeder.jss');
  var readAllLabel = get(fields, 'data.item.readAllLabel.field.value');
  var readAllLabelField = get(fields, 'data.item.readAllLabel');
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    googleApiReady = _React$useState18[0],
    setGoogleApiReady = _React$useState18[1];
  var readAllLinkField = get(fields, 'data.item.readAllLink.field');
  var readAllLinkHref = get(fields, 'data.item.readAllLink.field.value.href');
  var hasFAQs = pageEditing ? true : Boolean(get(fields, 'data.datasource.faqs.length') > 0);
  var items = hasFAQs ? get(fields, 'data.datasource.faqs') : [];
  var hasTabName = Boolean(get(fields, 'data.dictionary.dictionaryValues.length'));
  var tabName = hasTabName ? fields.data.dictionary.dictionaryValues : [];
  var _useInView = useInView({
      rootMargin: '200px 0px 200px 0px',
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var map = tabName.reduce(function (aggregator, currentValue) {
    return aggregator.set(currentValue.key.jss.value, currentValue.phrase.jss);
  }, new Map());
  var _fields$data = fields.data,
    tabTitleOverviewAnalyticsLabel = _fields$data.tabTitleOverviewAnalyticsLabel,
    navigationTabAnalytics = _fields$data.navigationTabAnalytics,
    overviewLinkAnalytics = _fields$data.overviewLinkAnalytics,
    overviewLiveAnalytics = _fields$data.overviewLiveAnalytics,
    bookingClickAnalytics = _fields$data.bookingClickAnalytics,
    faqExpandCollapseAnalytics = _fields$data.faqExpandCollapseAnalytics,
    faqReadAllAnalytics = _fields$data.faqReadAllAnalytics;
  var tabTitleOverview = map.get('Tab Title Overview');
  var tabTitleOverviewAnalyticsValue = get(tabTitleOverviewAnalyticsLabel, 'eventLab.jss.value', '');
  var tabTitleFAQs = map.get('Tab Title FAQs');
  var placeInfoRef = React.useRef(null);
  var middleArrIndex = Boolean(get(fields, 'data.datasource.faqs.length') > 0) ? Math.ceil(items.length / 2) : 0;
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    bookingButton = _React$useState20[0],
    setBookingButton = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    inWindowView = _React$useState22[0],
    setInWindowView = _React$useState22[1];
  var _useState3 = useState(function () {
      return canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  React.useEffect(function () {
    setInWindowView(inView);
  }, [inView]);
  var theme = get(sitecoreContext, 'themesOfPage');
  var setMultipleItems = function setMultipleItems(dataArray, isGoogleAvailble) {
    var dataArrayInfo = [];
    var counter = 0;
    var markers = [];
    dataArray && dataArray.map(function (item, index) {
      var website = websiteJSS || get(item, 'website.jss.value.url');
      var title = get(item, 'name.jss.value') || '';
      var telephone = telephoneJSS || get(item, 'phone.jss.value');
      var address = get(item, 'address.jss.value') || '';
      var email = get(item, 'email.jss.value') || emailJSS;
      var lat = get(item, 'latitude.jss.value') || '';
      var lng = get(item, 'longitude.jss.value') || '';
      var openingHoursVenue = get(item, 'openingHours.jss.value') || '';
      var pushlocation = function pushlocation(website, telephone, address, lat, lng, openingHoursVenue, title, tripAdvisorPriceLevel, email) {
        if (lat && lng) {
          dataArrayInfo.push({
            website: website,
            telephone: telephone,
            address: address,
            lat: lat,
            lng: lng,
            openingHoursVenue: openingHoursVenue,
            title: title,
            tripAdvisorPriceLevel: tripAdvisorPriceLevel,
            email: email
          });
        }
      };
      var updateState = function updateState(length, counter) {
        if (length === counter && dataArrayInfo.length) {
          // first location
          var _markers = [];
          var _website = dataArrayInfo[0].website || '';
          var _email = dataArrayInfo[0].email || '';
          var _telephone = dataArrayInfo[0].telephone || '';
          var _address = dataArrayInfo[0].address || '';
          var _lat = dataArrayInfo[0].lat || '';
          var _lng = dataArrayInfo[0].lng || '';
          var _openingHoursVenue = dataArrayInfo[0].openingHoursVenue || '';
          var _title = dataArrayInfo[0].title || '';
          var tripAdvisorPriceLevel = dataArrayInfo[0].tripAdvisorPriceLevel || '';
          setAllLocations([].concat(dataArrayInfo));
          updateMapState(_website, _telephone, _address, _email, _lat, _lng, _openingHoursVenue, tripAdvisorPriceLevel);
          setLocationTitle(_title);
          dataArrayInfo.map(function (location) {
            var lat = location.lat;
            var lng = location.lng;
            var title = location.title;
            _markers.push({
              lat: lat,
              lng: lng,
              title: title
            });
          });
          setMapState({
            lat: _lat,
            lng: _lng,
            activeMarker: 1,
            markers: _markers
          });
        }
      };
      if (isGoogleAvailble) {
        counter++;
        pushlocation(website, telephone, address, lat, lng, openingHoursVenue, title, tripAdvisorPriceLevelJSS, email);
        updateState(dataArray.length, counter);
        setLocationTitle(title);
      } else {
        counter++;
        markers.push({
          title: title,
          lat: lat,
          lng: lng
        });
        pushlocation(website, telephone, address, lat, lng, openingHoursVenue, title, tripAdvisorPriceLevelJSS, email);
        updateState(dataArray.length, counter);
        setMapState({
          lat: lat,
          lng: lng,
          activeMarker: 0,
          markers: markers
        });
      }
    });
  };
  var renderEvents = function renderEvents(isGoogleAvailble) {
    var isVenues = venues && venues.length >= 1;
    if (isVenues) {
      setMultipleItems(venues, isGoogleAvailble);
    } else {
      // IF NO VENUES
      var mapDefaultSettingsLatitude = get(sitecoreContext, 'configuration.mapDefaultSettings.latitude');
      var mapDefaultSettingsLongitude = get(sitecoreContext, 'configuration.mapDefaultSettings.longitude');

      //  context item has priority over locationTags
      if (latJSS || lngJSS) {
        setMapInfo({
          website: websiteJSS,
          telephone: telephoneJSS,
          address: addressJSS,
          email: emailJSS,
          lat: latJSS ? latJSS : mapDefaultSettingsLatitude,
          lng: lngJSS ? lngJSS : mapDefaultSettingsLongitude,
          openingHoursVenue: openingHoursJSS,
          bound: false,
          tripAdvisorPriceLevel: tripAdvisorPriceLevelJSS
        });
        setMapState({
          lat: latJSS ? latJSS : mapDefaultSettingsLatitude,
          lng: lngJSS ? lngJSS : mapDefaultSettingsLongitude,
          activeMarker: 1,
          markers: [{
            lat: latJSS ? latJSS : null,
            lng: lngJSS ? lngJSS : null,
            title: titleJSS
          }]
        });
      } else {
        if (hasLocationTagsJSS) {
          setMultipleItems(locationTagsJSS, isGoogleAvailble);
        }
      }
    }
  };
  var updateMapState = function updateMapState(website, telephone, address, email, latitude, longitude, openingHoursVenue, tripAdvisorPriceLevel) {
    var lat = Number(latitude);
    var lng = Number(longitude);
    setMapInfo(_objectSpread(_objectSpread({}, mapInfo), {}, {
      website: website,
      telephone: telephone,
      address: address,
      email: email,
      lat: lat,
      lng: lng,
      openingHoursVenue: openingHoursVenue,
      tripAdvisorPriceLevel: tripAdvisorPriceLevel
    }));
  };
  var renderPOIInfo = function renderPOIInfo(isGoogleAvailble) {
    if (!googlePlaceIds || !venues) {
      setBookingButton(true);
      if (googlePlaceIDPOI) {
        updateMapState(websiteJSS, telephoneJSS, addressJSS, emailJSS, latJSS, lngJSS, openingHoursJSS, tripAdvisorPriceLevelJSS);
        setLocationTitle(titleJSS);
        setMapState({
          lat: latJSS,
          lng: lngJSS,
          activeMarker: 0,
          markers: [{
            lat: latJSS,
            lng: lngJSS,
            address: addressJSS
          }]
        });
      }
      updateMapState(websiteJSS, telephoneJSS, addressJSS, emailJSS, latJSS, lngJSS, openingHoursJSS, tripAdvisorPriceLevelJSS);
    }
  };
  React.useEffect(function () {
    var urlParams = new URLSearchParams(document.location.search);
    if (isChina === undefined) {
      var isC = Boolean(urlParams.get('isChina') === 'true');
      setIsChina(isC);
    }
    if (pageEditing) {
      setActiveTabItem('Tab Title FAQs');
    }
  });
  var handleAccordionItemClick = React.useCallback(function (e, id, isActive) {
    e.preventDefault();
    var nextActiveItemsIds = isActive ? activeItemsIds.filter(function (i) {
      return i !== id;
    }) : [].concat(_toConsumableArray(activeItemsIds), [id]);
    setActiveItemsIds(nextActiveItemsIds);
  }, [activeItemsIds]);
  if (!fields || !fields.data || !fields.data.contextItem) {
    console.info('PracticalInformation component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[PracticalInformation component is empty: please provide data source]");
    }
    return null;
  }
  var renderTabName = function renderTabName() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("li", {
      className: "t__item ".concat('Tab Title Overview' === activeTabItem ? 'active' : ''),
      "data-tab": "1",
      onClick: function onClick(e) {
        changeActiveTab(e, 'Tab Title Overview');
        tealiumClickFunc(tealiumMergeClickData(navigationTabAnalytics, params), tabTitleOverviewAnalyticsValue);
      },
      tabIndex: activeTabItem === 'Tab Title Overview' ? -1 : 0,
      onKeyPress: function onKeyPress(e) {
        if (e.which === 13 || e.which === 32) {
          e.preventDefault();
          changeActiveTab(e, 'Tab Title Overview');
          tealiumClickFunc(tealiumMergeClickData(navigationTabAnalytics, params), tabTitleOverviewAnalyticsValue);
        }
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      "aria-label": "Tab Title Overview",
      "aria-labelledby": "Tab Title Overview"
    }, tabTitleOverview && tabTitleOverview.value)), hasFAQs && /*#__PURE__*/React.createElement("li", {
      className: "t__item ".concat('Tab Title FAQs' === activeTabItem ? 'active' : ''),
      "data-tab": "3",
      onClick: function onClick(e) {
        changeActiveTab(e, 'Tab Title FAQs');
        tealiumClickFunc(tealiumMergeClickData(navigationTabAnalytics, params), tabTitleFAQs.value);
      },
      tabIndex: activeTabItem === 'Tab Title FAQs' ? -1 : 0,
      onKeyPress: function onKeyPress(e) {
        if (e.which === 13 || e.which === 32) {
          e.preventDefault();
          changeActiveTab(e, 'Tab Title FAQs');
          tealiumClickFunc(tealiumMergeClickData(navigationTabAnalytics, params), tabTitleFAQs.value);
        }
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      "aria-label": "Tab Title FAQs",
      "aria-labelledby": "Tab Title FAQs"
    }, tabTitleFAQs && tabTitleFAQs.value, " ")));
  };
  var dayOfWeekShort = new Array();
  for (var i = 1; i <= 7; i++) {
    var day = new Date("1999/8/".concat(i)).toLocaleDateString(currentLang, {
      weekday: 'short'
    });
    dayOfWeekShort.push(day);
  }
  var dayOfWeek = new Array();
  for (var _i = 1; _i <= 7; _i++) {
    var _day = new Date("1999/8/".concat(_i)).toLocaleDateString(currentLang, {
      weekday: 'long'
    });
    dayOfWeek.push(_day);
  }
  var monthsFull = new Array();
  for (var _i2 = 1; _i2 <= 12; _i2++) {
    var month = new Date("1999/".concat(_i2, "/1")).toLocaleDateString(currentLang, {
      month: 'long'
    });
    monthsFull.push(month);
  }
  var monthsShort = new Array();
  for (var _i3 = 1; _i3 <= 12; _i3++) {
    var _month = new Date("1999/".concat(_i3, "/1")).toLocaleDateString(currentLang === 'en' ? 'en-GB' : currentLang, {
      month: 'short'
    });
    monthsShort.push(_month);
  }
  var closedText = getDictionaryItem(dictionary, 'closed');
  var openText = getDictionaryItem(dictionary, 'Open');
  var parseTime = function parseTime(time) {
    var hour = parseInt(time.substr(0, 2));
    var min = parseInt(time.substr(2, 2));
    // if (hour === 0 && min === 0) return `12:00am`;
    if (hour === 0 && min === 0) {
      return "00:00";
    }

    // let daySide = 'am';

    // if (hour > 11) {
    //   daySide = 'pm';
    // }

    // if (hour > 12) {
    //   hour = hour - 12;
    // }

    if (hour === 0) {
      hour = '00';
    } else if (hour < 10 && hour > 0) {
      hour = "0".concat(hour);
    }
    if (min === 0) {
      min = '00';
    } else if (min < 10 && min > 0) {
      min = "0".concat(min);
    }
    return "".concat(hour, ":").concat(min);
    // return `${hour}${min}${daySide}`;
  };
  var getTodayTime = function getTodayTime(timeOpen, timeClose) {
    var hourOpen = timeOpen.substr(0, 2);
    var minOpen = timeOpen.substr(2, 2);
    var hourClose = timeClose.substr(0, 2);
    var minClose = timeClose.substr(2, 2);
    return "".concat(hourOpen, ":").concat(minOpen, " - ").concat(hourClose, ":").concat(minClose);
  };
  var parseOpenTimings = function parseOpenTimings(periods) {
    // condition for always open
    if (periods.length === 1 && periods[0].open.day === 0 && periods[0].open.time === '0000') {
      return {
        alwaysOpen: true
      };
    }
    var today = new Date().getDay();
    var daysObj = dayOfWeek.map(function (item) {
      return {
        day: item,
        time: closedText
      };
    });
    var firstDay = dayOfWeekShort[periods[0].open.day];
    var lastDay = dayOfWeekShort[periods[periods.length - 1].open.day];
    var dayFirstToLast = "".concat(firstDay, "-").concat(lastDay);
    var timeOfToday = '';
    var _iterator = _createForOfIteratorHelper(periods),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _day2 = _step.value;
        var openingTime = parseTime(_day2.open.time);
        var closingTime = parseTime(_day2.close.time);
        daysObj[_day2.open.day].time = "".concat(daysObj[_day2.open.day].time !== 'Closed' ? daysObj[_day2.open.day].time : '', "\n\t\t\t").concat(openingTime, " - ").concat(closingTime);
        if (today === _day2.open.day) timeOfToday = "".concat(timeOfToday !== '' ? timeOfToday + ',' : '').concat(getTodayTime(_day2.open.time, _day2.close.time));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return {
      dayFirstToLast: dayFirstToLast,
      timeOfToday: timeOfToday,
      daysObj: daysObj
    };
  };
  var renderTiming = function renderTiming(item) {
    var timeInput;
    if (item.periods) {
      timeInput = item.periods;
    } else {
      timeInput = JSON.parse(item);
      if (!(Array.isArray(timeInput) && timeInput.length)) {
        return false;
      }
    }
    var openTimings = parseOpenTimings(timeInput);
    if (openTimings) {
      var alwaysOpen = openTimings.alwaysOpen ? true : false;
      var daysList = alwaysOpen ? [] : openTimings.daysObj;
      var timeOfToday = openTimings.timeOfToday;
      if (rtl) timeOfToday = timeOfToday && timeOfToday.split(' ').reverse().join(' ');
      return /*#__PURE__*/React.createElement("div", {
        className: "details-box"
      }, openTimings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "details-icon__image"
      }, /*#__PURE__*/React.createElement(IconTime, {
        className: "details-icon__img ".concat(theme && theme.primary ? 'brand__item' : '')
      })), /*#__PURE__*/React.createElement("div", {
        className: "details-box__item address-timing ".concat(alwaysOpen ? 'address-timing--nohours' : ''),
        onClick: function onClick(e) {
          var isExpand = addresTiming(e);
          tealiumClickFunc(tealiumMergeClickData(overviewLinkAnalytics, params), [isExpand ? 'Expand' : 'Collapse']);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "address-timing__text"
      }, alwaysOpen ? openText : "".concat(openTimings.dayFirstToLast).concat(timeOfToday && ':', " ").concat(timeOfToday), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "address-timing__text--icon"
      })), !alwaysOpen && /*#__PURE__*/React.createElement("div", {
        className: "address-timing__list"
      }, daysList && daysList.map(function (item, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "address-timing__item",
          key: index
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            wordSpacing: "5px"
          }
        }, "".concat(item.day), ": "), "".concat(item.time));
      })))));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  };
  var renderItem = function renderItem(item, pageEditing) {
    var isActive = pageEditing || activeItemsIds.includes(item.title.jss.value);
    var titleField = get(item, 'title.jss');
    var description = get(item, 'description.jss');
    return /*#__PURE__*/React.createElement("div", {
      className: "accordion__list",
      key: item.title.jss.value
    }, /*#__PURE__*/React.createElement("p", {
      className: "accordion__heading body-medium",
      onClick: function onClick(e) {
        if (!pageEditing) {
          handleAccordionItemClick(e, item.title.jss.value, isActive);
          tealiumClickFunc(tealiumMergeClickData(faqExpandCollapseAnalytics, params), "".concat(isActive ? 'Collapse' : 'Expand'));
        }
      },
      onKeyPress: function onKeyPress(e) {
        if (e.which === 32 && !pageEditing) {
          e.preventDefault();
          handleAccordionItemClick(e, item.title.jss.value, isActive);
          tealiumClickFunc(tealiumMergeClickData(faqExpandCollapseAnalytics, params), "".concat(isActive ? 'Collapse' : 'Expand'));
        }
      }
    }, /*#__PURE__*/React.createElement(Text, {
      tag: pageEditing ? 'span' : 'a',
      className: "accordion__anchor",
      href: "/",
      field: titleField,
      "data-cy": "accordion-faq-anchor"
    }), !pageEditing && /*#__PURE__*/React.createElement("span", {
      className: "accordion__icon"
    }, isActive ? /*#__PURE__*/React.createElement(IconMinus, null) : /*#__PURE__*/React.createElement(IconPlus, null))), isActive && /*#__PURE__*/React.createElement("div", {
      className: "accordion__content"
    }, /*#__PURE__*/React.createElement(RichText, {
      tag: "p",
      className: "body-small accordion__desc",
      field: description,
      "data-cy": "accordion-faq-item-content"
    })));
  };
  var addresTiming = function addresTiming(event) {
    event.preventDefault();
    return event.currentTarget.classList.toggle('address-timing--active');
  };
  function changeActiveTab(event, tabKey) {
    event.preventDefault();
    setActiveTabItem(tabKey);
    if (tabKey === 'TabTitleAccommodation') {}
  }
  var markerCallback = function markerCallback(marker, _ref2) {
    var lat = _ref2.lat,
      lng = _ref2.lng;
    var marker_lat = marker && (marker && marker.position && marker.position.lat() || marker.latlng && marker.latlng.lat);
    var marker_lng = marker && (marker && marker.position && marker.position.lng() || marker.latlng && marker.latlng.lng);
    var index = allLocations.filter(function (item, index) {
      var itemlat = Number(item.lat);
      var itemlng = Number(item.lng);
      if (itemlat === marker_lat && itemlng === marker_lng) {
        var website = item.website,
          email = item.email,
          telephone = item.telephone,
          address = item.address,
          openingHoursVenue = item.openingHoursVenue,
          tripAdvisorPriceLevel = item.tripAdvisorPriceLevel;
        updateMapState(website, telephone, address, email, itemlat, itemlng, openingHoursVenue, tripAdvisorPriceLevel);
        setMapState(_objectSpread(_objectSpread({}, mapState), {}, {
          lat: lat,
          lng: lng
        }));
        setLocationTitle(item.title);
      }
    });
  };
  var addBorderRadiusToTheMap = function addBorderRadiusToTheMap() {
    var parentElement = document.getElementById("map");
    if (isNotNil(parentElement)) {
      parentElement.getElementsByTagName("div")[2].style.borderRadius = "8px";
    }
  };
  var apiReady = function apiReady() {
    addBorderRadiusToTheMap();
    setGoogleApiReady(true);
    renderEvents(true);
  };
  /*eslint-disable */
  React.useEffect(function () {
    if (googleApiReady) {
      renderEvents(true);
    }
    //setInWindowView(inView);
  }, [fields.data.contextItem.title.jss.value]);
  React.useEffect(function () {
    renderPOIInfo(true);
    renderEvents(true);
  }, []);
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener("resize", function () {
        setIsMobile(window.matchMedia("(max-width: 992px)").matches);
      });
    }
    return function () {
      if (canUseDOM) {
        window.addEventListener("resize", function () {
          setIsMobile(window.matchMedia("(max-width: 992px)").matches);
        });
      }
    };
  }, []);

  /*eslint-disable */
  var renderGoogleMap = function renderGoogleMap() {
    if (isStaticMap) {
      if (hasGoogleMapsImage) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            width: '100%',
            height: '100%'
          }
        }, googleMapsImageSrc && /*#__PURE__*/React.createElement("img", {
          className: "google-map-static",
          src: BASE_URL + googleMapsImageSrc,
          alt: googleMapsImageAlt
        }), googleMapsImageSrc ? null : /*#__PURE__*/React.createElement("b", null, "please, provide google map image"));
      }
      return /*#__PURE__*/React.createElement(GoogleMapStatic, {
        theme: get(sitecoreContext, 'themesOfPage'),
        name: locationTitle,
        lat: mapState.lat,
        long: mapState.lng,
        resolution: "800x600",
        mapState: mapState,
        zoom: "14"
      });
    } else {
      return /*#__PURE__*/React.createElement(GoogleMap, {
        zoom: 14,
        allowZoomControl: false,
        callback: apiReady,
        markerCallback: markerCallback,
        mapState: mapState,
        theme: _objectSpread(_objectSpread({}, get(sitecoreContext, 'themesOfPage')), {
          primary: ColorHex,
          primary_active: ActiveColorHex
        })
      });
    }
  };
  var renderDisclaimer = function renderDisclaimer() {
    if (!disclaimerText) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "disclaimerContainer"
    }, disclaimerOpen ? /*#__PURE__*/React.createElement("div", {
      className: "disclaimerTextBlock"
    }, /*#__PURE__*/React.createElement("span", {
      className: "disclaimerText"
    }, disclaimerText), /*#__PURE__*/React.createElement(IconCloseX, {
      className: "disclaimerIcon",
      onClick: function onClick() {
        return setDisclaimerOpen(false);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "disclaimerArrowWrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "disclaimerArrow"
    }))) : null, /*#__PURE__*/React.createElement(IconDisclaimer, {
      className: "disclaimerIcon",
      onClick: function onClick() {
        return setDisclaimerOpen(function (prev) {
          return !prev;
        });
      }
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    id: "overview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-heading col-xs-12"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "t__list scroll-no-style"
  }, renderTabName()), /*#__PURE__*/React.createElement("div", {
    className: "line"
  })), /*#__PURE__*/React.createElement("div", {
    className: "t-body col-xs-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: activeTabItem === 'Tab Title Overview' || activeTabItem === 'TabTitleAccommodation' ? 't-content active' : 't-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters t-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 col-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "maps-container"
  }, /*#__PURE__*/React.createElement("div", {
    ref: placeInfoRef,
    id: "place-info"
  }), /*#__PURE__*/React.createElement("div", {
    id: "map",
    ref: ref,
    onClick: function onClick() {
      setIsStaticMap(false);
    }
  }, !isChina && inWindowView && renderGoogleMap(), isChina && /*#__PURE__*/React.createElement(OSM, {
    zoom: 14,
    customMarker: false,
    callback: apiReady,
    markerCallback: markerCallback,
    mapState: mapState
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-3 col-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-box__parent"
  }, mapInfo.address && /*#__PURE__*/React.createElement("div", {
    className: "details-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement(IconLocation, {
    className: "details-icon__img ".concat(theme && theme.primary ? 'brand__item' : '')
  })), /*#__PURE__*/React.createElement("div", {
    className: "details-box__item address-heading"
  }, /*#__PURE__*/React.createElement("p", {
    className: "address-details"
  }, mapInfo.address))), mapInfo.website && /*#__PURE__*/React.createElement("div", {
    className: "details-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement(IconLink, {
    className: "details-icon__img ".concat(theme && theme.primary ? 'brand__item' : '')
  })), /*#__PURE__*/React.createElement("a", {
    className: "details-box__item address-link",
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "".concat(mapInfo.website, " | Opens in a new window"),
    href: mapInfo.website,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(overviewLinkAnalytics, params), mapInfo.website);
    }
  }, mapInfo.website &&
  //replace http and https
  mapInfo.website.replace(/(^\w+:|^)\/\//, ''))), mapInfo.telephone && /*#__PURE__*/React.createElement("div", {
    className: "details-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement(IconMobile, {
    className: "details-icon__img ".concat(theme && theme.primary ? 'brand__item' : '')
  })), /*#__PURE__*/React.createElement("a", {
    className: "details-box__item address-mobile",
    href: 'tel:' + mapInfo.telephone,
    "aria-label": "Telephone",
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(overviewLinkAnalytics, params), mapInfo.telephone);
    }
  }, mapInfo.telephone)), mapInfo.email && /*#__PURE__*/React.createElement("div", {
    className: "details-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement(IconEmail, {
    className: "details-icon__img ".concat(theme && theme.primary ? 'brand__item' : '')
  })), /*#__PURE__*/React.createElement("a", {
    className: "details-box__item address-mobile",
    href: 'mailto:' + mapInfo.email,
    "aria-label": "Email",
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(overviewLinkAnalytics, params), mapInfo.email);
    }
  }, mapInfo.email)), mapInfo.openingHoursVenue && renderTiming(mapInfo.openingHoursVenue), mapInfo.tripAdvisorPriceLevel && /*#__PURE__*/React.createElement("div", {
    className: "details-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement(IconFee, {
    className: "details-icon__img ".concat(theme && theme.primary ? 'brand__item' : '')
  })), /*#__PURE__*/React.createElement("div", {
    className: "details-box__item"
  }, mapInfo.tripAdvisorPriceLevel))), disclaimerText && isMobile ? renderDisclaimer() : null, buyLinkWebsite && bookingButton && /*#__PURE__*/React.createElement("div", {
    className: "details-box details-box-button"
  }, ' ', /*#__PURE__*/React.createElement("a", {
    href: buyLinkWebsite,
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "".concat(bookTickets, " | Opens in a new window"),
    className: "btn btn-primary book-tickets",
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(overviewLinkAnalytics, params), getLastPartInURL(buyLinkWebsite));
    }
  }, bookTickets), ' '), disclaimerText && !isMobile ? renderDisclaimer() : null))), hasFAQs && /*#__PURE__*/React.createElement("div", {
    className: activeTabItem !== 'Tab Title FAQs' ? 't-content' : 't-content active'
  }, /*#__PURE__*/React.createElement("div", {
    className: "row t-box "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-faq",
    "data-cy": "accordion-faq"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 accordion-main-heading",
    field: titleField,
    "data-cy": "accordion-faq-title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "accordion accordion--faq"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion__col accordion__col--left"
  }, items && items.map(function (item, index) {
    if (index < middleArrIndex) return renderItem(item, pageEditing);
    return null;
  })), /*#__PURE__*/React.createElement("div", {
    className: "accordion__col accordion__col--right"
  }, items && items.map(function (item, index) {
    if (index >= middleArrIndex) return renderItem(item, pageEditing);
    return null;
  }))), pageEditing ? /*#__PURE__*/React.createElement(SitecoreLink, {
    className: "btn btn-link accordion__readmore",
    field: readAllLinkField,
    title: readAllLabel ? readAllLabel : '[Link]'
  }, /*#__PURE__*/React.createElement(Text, {
    field: readAllLabelField,
    tag: "span",
    className: "btn-link__text"
  }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon"
  })) : readAllLabel && readAllLinkHref && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-link accordion__readmore",
    href: readAllLinkHref,
    dataCy: "accordion-faq-read-more",
    title: readAllLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-link__text"
  }, readAllLabel), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon"
  })))))))))))))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1rtqh5j";
var ltrStyles = "ll2t3pm";
var rtlStyles = "r1is3pkz";
export default PracticalInformation;